<template lang="pug">
div.field
	.control
		.select
			select(v-model="selected")
				option(v-for="c of employees", :value="c") 
					span.margin-right [{{c.code}}]:  
					span.margin-right {{c.name.first}} 
					span.margin-right(v-if='c.name.middle') {{c.name.middle[0]}}. 
					span.margin-right {{c.name.last}} 
					span(v-if='c.name.suffix') {{c.name.suffix}}

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EmployeePicker",

  computed: {
    ...mapState(["employee", "employees"]),

    selected: {
      get() {
        return this.$store.state.employee;
      },
      set(value) {
        this.$store.commit("employee", value);
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
</style>